import React, { useRef } from 'react'
import { BarChart, CartesianGrid, ResponsiveContainer } from 'recharts'

import { ChartTooltip, XAxis, YAxis, Bar } from '../../../Visualisation/components'
import { useBarChartHoverIndex } from '../../../Visualisation/hooks'
import { formatGraphData, getAxisDomain } from '../../../Visualisation/helpers'
import { GraphPayload } from '../../../Visualisation/types'

type Props = {
  data?: GraphPayload
  graphHeight?: number
}

const ExpensesPerAdvertiserChart: React.FC<Props> = ({ data, graphHeight }) => {
  const chartRef = useRef<any>(null)
  const [hoveredIndex, handleBarMouseMove, handleBarMouseLeave] = useBarChartHoverIndex()

  const formattedData = formatGraphData('expenses', undefined, data, value =>
    Number(value).toFixed()
  )
  const domain = getAxisDomain(formattedData, 'expenses')

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight}>
      <BarChart
        ref={chartRef}
        data={formattedData}
        barCategoryGap={3}
        maxBarSize={50}
        margin={{ top: 0, left: 0, right: 0, bottom: 0 }}
        onMouseMove={handleBarMouseMove}
        onMouseLeave={handleBarMouseLeave}
      >
        <defs>
          <linearGradient id="color-red" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#FDC3C8" />
            <stop offset="1" stopColor="#FECDD1" />
          </linearGradient>
          <linearGradient id="color-red-hovered" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#FB606D" />
            <stop offset="1" stopColor="#FC7E88" />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: 'three', chartType: 'bar', barSize: 50 })}
        {YAxis({ dataKey: 'expenses', unit: '₽', domain })}
        <CartesianGrid stroke="#CED8FD" vertical={false} strokeDasharray="5 5" />
        {ChartTooltip({ cursor: false })}
        {Bar({
          dataKey: 'expenses',
          stroke: '#FB606D',
          unit: '₽',
          hoveredIndex,
          borderRadius: 15,
          graphData: formattedData,
          color: 'url(#color-red)',
          colorHovered: 'url(#color-red-hovered'
        })}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ExpensesPerAdvertiserChart
